module.exports = __webpack_public_path__ + "static/img/banner_3.94edad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_3.jpg
// module id = GurO
// module chunks = 0